import { SortOrder, SortType } from '@fullstory/proto/fs/api/metrics';
import { AlertDirection, ThresholdOperation } from '@fullstory/proto/fs/api/proactiveinsights';
import { TimeInterval } from '@fullstory/proto/fs/api/segment';
import { Visibility } from '@fullstory/proto/fs/gcloud/dstore/protoauditstore';
import {
  GetAlertsListViewResponse,
  GetCreateAlertViewResponse,
  User,
  UserAlertPreference,
} from '@fullstory/proto/fs/services/dx-objects';
import { TrendFrequency } from '@fullstory/proto/fs/services/search-settings/visualizationsettings';
import { Timestamp, int64 } from '@fullstory/proto/google/protobuf';

export const DEFAULT_ALL_USERS: User[] = [
  {
    email: 'test1@fullstory.com',
    firstName: 'Test',
    lastName: 'Account 1',
  },
  {
    email: 'test2@fullstory.com',
    firstName: 'Test',
    lastName: 'Account 2',
  },
  {
    email: 'test3@fullstory.com',
    firstName: 'Test',
    lastName: 'Account 3',
  },
  {
    email: 'test4@fullstory.com',
    firstName: 'Test',
    lastName: 'Account 4',
  },
  {
    email: 'test5@fullstory.com',
    firstName: 'Test',
    lastName: 'Account 5',
  },
  {
    email: 'test6@fullstory.com',
    firstName: 'Test',
    lastName: 'Account 6',
  },
  {
    email: 'test7@fullstory.com',
    firstName: 'Test',
    lastName: 'Account 7',
  },
];

export const GET_CREATE_ALERT_VIEW_RESPONSE: GetCreateAlertViewResponse = {
  metricRecord: {
    metric: {
      id: 'X5LteQy0u1dP',
      name: 'JV',
      description: '',
      metric: {
        single: {
          event: {
            primary: {
              errorClick: {
                withElementId: {
                  value: ['fHU2SLTPiaHP'],
                  spec: [],
                },
              },
            },
            deps: [],
          },
          aggregation: {
            numeric: {
              property: {
                builtInProperty: 5,
              },
              aggregation: 2,
            },
          },
          rollingWindow: 0,
          rollingWindowType: 0,
          rollingWindowInterval: TimeInterval.TIME_INTERVAL_INVALID,
        },
      },
      trend: {
        frequency: 1,
        computePast: false,
        segmentId: [],
        conversionId: [],
        displayAs: {
          displayPrecision: 1,
          number: true,
        },
        timeRange: {
          startTime: 'NOW/DAY-6DAY',
          endTime: 'NOW/DAY+1DAY',
        },
        segment: [
          {
            segmentId: 'everyone',
            segmentScope: 3,
          },
        ],
        dimensionSettings: {
          dimension: null,
          dimensions: [],
          sortOrder: SortOrder.SORT_ORDER_DESC,
          sortByDefault: false,
          sortType: SortType.SORT_TYPE_INVALID,
          limit: 50,
          computeTopLevel: false,
          computeNumGroups: false,
          allowAllPartialResults: false,
          noFallback: false,
        },
        timeRangeComparison: null,
        color: 0,
      },
      funnelFilter: null,
    },
    metadata: {
      lastUpdated: Timestamp.fromDate(new Date('2023-03-15T13:57:19.137375Z')),
      lastUpdatedBy: 'johnverrone@fullstory.com',
      created: Timestamp.fromDate(new Date('2023-03-08T15:07:34.815718Z')),
      createdBy: 'johnverrone@fullstory.com',
      archived: false,
      visibility: Visibility.PUBLIC,
      version: int64.fromNumber(1678888639137),
      sequentialVersion: int64.fromNumber(8),
    },
    isDcmCreated: false,
    isCanned: false,
  },
  legendItems: [
    {
      segmentLegend: {
        id: 'everyone',
        name: 'Everyone',
      },
    },
  ],
  dataTables: [
    {
      table: [
        {
          startTime: Timestamp.fromDate(new Date('2023-03-09T00:00:00Z')),
          endTime: Timestamp.fromDate(new Date('2023-03-10T00:00:00Z')),
          groups: [],
          value: 1,
          defaultValue: 0,
          isPartialPeriod: false,
        },
        {
          startTime: Timestamp.fromDate(new Date('2023-03-10T00:00:00Z')),
          endTime: Timestamp.fromDate(new Date('2023-03-11T00:00:00Z')),
          groups: [],
          value: 42,
          defaultValue: 0,
          isPartialPeriod: false,
        },
        {
          startTime: Timestamp.fromDate(new Date('2023-03-11T00:00:00Z')),
          endTime: Timestamp.fromDate(new Date('2023-03-12T00:00:00Z')),
          groups: [],
          value: 0,
          defaultValue: 0,
          isPartialPeriod: false,
        },
        {
          startTime: Timestamp.fromDate(new Date('2023-03-12T00:00:00Z')),
          endTime: Timestamp.fromDate(new Date('2023-03-13T00:00:00Z')),
          groups: [],
          value: 0,
          defaultValue: 0,
          isPartialPeriod: false,
        },
        {
          startTime: Timestamp.fromDate(new Date('2023-03-13T00:00:00Z')),
          endTime: Timestamp.fromDate(new Date('2023-03-14T00:00:00Z')),
          groups: [],
          value: 7,
          defaultValue: 0,
          isPartialPeriod: false,
        },
        {
          startTime: Timestamp.fromDate(new Date('2023-03-14T00:00:00Z')),
          endTime: Timestamp.fromDate(new Date('2023-03-15T00:00:00Z')),
          groups: [],
          value: 100, // max value of chart
          defaultValue: 0,
          isPartialPeriod: false,
        },
        {
          startTime: Timestamp.fromDate(new Date('2023-03-15T00:00:00Z')),
          endTime: Timestamp.fromDate(new Date('2023-03-16T00:00:00Z')),
          groups: [],
          value: 27,
          defaultValue: 0,
          isPartialPeriod: false,
        },
      ],
      numGroups: int64.fromNumber(0),
    },
  ],
  previousDataTables: [
    {
      table: [
        {
          startTime: Timestamp.fromDate(new Date('2023-03-08T00:00:00Z')),
          endTime: Timestamp.fromDate(new Date('2023-03-09T00:00:00Z')),
          groups: [],
          value: 27,
          defaultValue: 0,
          isPartialPeriod: false,
        },
        {
          startTime: Timestamp.fromDate(new Date('2023-03-09T00:00:00Z')),
          endTime: Timestamp.fromDate(new Date('2023-03-10T00:00:00Z')),
          groups: [],
          value: 1,
          defaultValue: 0,
          isPartialPeriod: false,
        },
        {
          startTime: Timestamp.fromDate(new Date('2023-03-10T00:00:00Z')),
          endTime: Timestamp.fromDate(new Date('2023-03-11T00:00:00Z')),
          groups: [],
          value: 42,
          defaultValue: 0,
          isPartialPeriod: false,
        },
        {
          startTime: Timestamp.fromDate(new Date('2023-03-11T00:00:00Z')),
          endTime: Timestamp.fromDate(new Date('2023-03-12T00:00:00Z')),
          groups: [],
          value: 0,
          defaultValue: 0,
          isPartialPeriod: false,
        },
        {
          startTime: Timestamp.fromDate(new Date('2023-03-12T00:00:00Z')),
          endTime: Timestamp.fromDate(new Date('2023-03-13T00:00:00Z')),
          groups: [],
          value: 0,
          defaultValue: 0,
          isPartialPeriod: false,
        },
        {
          startTime: Timestamp.fromDate(new Date('2023-03-13T00:00:00Z')),
          endTime: Timestamp.fromDate(new Date('2023-03-14T00:00:00Z')),
          groups: [],
          value: 7,
          defaultValue: 0,
          isPartialPeriod: false,
        },
      ],
      numGroups: int64.fromNumber(0),
    },
  ],
  alertNotificationConfig: null,
  allUsers: DEFAULT_ALL_USERS,
};

export const GET_CREATE_ALERT_VIEW_RESPONSE_WITH_PERCENTAGE: GetCreateAlertViewResponse = {
  metricRecord: {
    metric: {
      id: 'X5LteQy0u1dP',
      name: 'JV',
      description: '',
      metric: {
        dual: {
          first: {
            event: {
              primary: {
                click: {
                  withElementId: {
                    value: ['fHU2SLTPiaHP'],
                    spec: [],
                  },
                },
              },
              deps: [],
            },
            aggregation: {
              default: {},
            },
            rollingWindow: 0,
            rollingWindowType: 0,
            rollingWindowInterval: TimeInterval.TIME_INTERVAL_INVALID,
          },
          second: {
            event: {
              primary: null,
              deps: [],
            },
            aggregation: {
              unique: 1,
            },
            rollingWindow: 0,
            rollingWindowType: 0,
            rollingWindowInterval: TimeInterval.TIME_INTERVAL_INVALID,
          },
          operator: 4,
          dimensionApplication: 0,
        },
      },
      trend: {
        frequency: 2,
        computePast: false,
        segmentId: [],
        conversionId: [],
        displayAs: {
          displayPrecision: 2,
          percent: true,
        },
        timeRange: {
          startTime: 'NOW/HOUR-23HOUR',
          endTime: 'NOW/HOUR+1HOUR',
        },
        segment: [
          {
            segmentId: 'everyone',
            segmentScope: 3,
          },
        ],
        dimensionSettings: {
          dimension: null,
          dimensions: [],
          sortOrder: SortOrder.SORT_ORDER_DESC,
          sortByDefault: false,
          sortType: SortType.SORT_TYPE_INVALID,
          limit: 50,
          computeTopLevel: false,
          computeNumGroups: false,
          allowAllPartialResults: false,
          noFallback: false,
        },
        timeRangeComparison: null,
        color: 0,
      },
      funnelFilter: null,
    },
    metadata: {
      lastUpdated: Timestamp.fromDate(new Date('2023-04-12T14:21:57.844347Z')),
      lastUpdatedBy: 'johnverrone@fullstory.com',
      created: Timestamp.fromDate(new Date('2023-03-08T15:07:34.815718Z')),
      createdBy: 'johnverrone@fullstory.com',
      archived: false,
      visibility: Visibility.PUBLIC,
      version: int64.fromNumber(1),
      sequentialVersion: int64.fromNumber(58),
    },
    isDcmCreated: false,
    isCanned: false,
  },
  legendItems: [
    {
      segmentLegend: {
        id: 'everyone',
        name: 'Everyone',
      },
    },
  ],
  dataTables: [
    {
      table: [
        {
          startTime: Timestamp.fromDate(new Date('2023-04-11T17:00:00Z')),
          endTime: Timestamp.fromDate(new Date('2023-04-11T18:00:00Z')),
          groups: [],
          value: 0.009, // 0.9%
          defaultValue: 0,
          isPartialPeriod: false,
        },
        {
          startTime: Timestamp.fromDate(new Date('2023-04-11T18:00:00Z')),
          endTime: Timestamp.fromDate(new Date('2023-04-11T19:00:00Z')),
          groups: [],
          value: 0.002, // 0.2%
          defaultValue: 0,
          isPartialPeriod: false,
        },
        {
          startTime: Timestamp.fromDate(new Date('2023-04-11T19:00:00Z')),
          endTime: Timestamp.fromDate(new Date('2023-04-11T20:00:00Z')),
          groups: [],
          value: 0.001, // 0.1%
          defaultValue: 0,
          isPartialPeriod: false,
        },
      ],
      numGroups: int64.fromNumber(0),
    },
  ],
  previousDataTables: [
    {
      table: [
        {
          startTime: Timestamp.fromDate(new Date('2023-04-11T16:00:00Z')),
          endTime: Timestamp.fromDate(new Date('2023-04-11T17:00:00Z')),
          groups: [],
          value: 0.001, // 0.1%
          defaultValue: 0,
          isPartialPeriod: false,
        },
        {
          startTime: Timestamp.fromDate(new Date('2023-04-11T17:00:00Z')),
          endTime: Timestamp.fromDate(new Date('2023-04-11T18:00:00Z')),
          groups: [],
          value: 0.009, // 0.9%
          defaultValue: 0,
          isPartialPeriod: false,
        },
        {
          startTime: Timestamp.fromDate(new Date('2023-04-11T18:00:00Z')),
          endTime: Timestamp.fromDate(new Date('2023-04-11T19:00:00Z')),
          groups: [],
          value: 0.002, // 0.2%
          defaultValue: 0,
          isPartialPeriod: false,
        },
      ],
      numGroups: int64.fromNumber(0),
    },
  ],
  alertNotificationConfig: null,
  allUsers: [],
};

export const GET_ALERTS_LIST_VIEW_RESPONSE: GetAlertsListViewResponse = {
  rows: [
    {
      alertId: 'ZdXuJUJX1LCh',
      alertName: '% above 35%',
      lastAlertTime: {
        start: null,
        end: null,
      },
      createdBy: {
        email: 'tester@fullstory.com',
        firstName: 'Tester',
        lastName: 'Account',
      },
      destinationIds: [],
      metricId: '1234',
      metricName: 'Test metric',
      timeZone: 'UTC',
      frequency: TrendFrequency.TREND_FREQUENCY_DAILY,
      accessControl: {
        id: '',
        canRead: true,
        canUpdate: true,
        canDelete: true,
        canCreate: true,
        owners: ['tester@fullstory.com'],
      },
      subscribedUsers: [
        {
          user: {
            email: 'tester@fullstory.com',
            firstName: 'Test',
            lastName: 'Account',
          },
          subscribedInApp: true,
          subscribedEmail: false,
        },
      ],
    },
    {
      alertId: 'ROxF1fviIwht',
      alertName: '% above 40',
      lastAlertTime: {
        start: null,
        end: null,
      },
      createdBy: {
        email: 'test@fullstory.com',
        firstName: 'Test',
        lastName: 'Account',
      },
      destinationIds: [],
      metricId: '1234',
      metricName: 'A different metric',
      timeZone: 'UTC',
      frequency: TrendFrequency.TREND_FREQUENCY_DAILY,
      accessControl: {
        id: '',
        canRead: true,
        canUpdate: true,
        canDelete: true,
        canCreate: true,
        owners: ['test@fullstory.com'],
      },
      subscribedUsers: [
        {
          user: {
            email: 'test@fullstory.com',
            firstName: 'Test',
            lastName: 'Account',
          },
          subscribedInApp: true,
          subscribedEmail: false,
        },
      ],
    },
  ],
  atAlertLimit: false,
  orgLimit: int64.fromNumber(300),
  alertCount: int64.fromNumber(2),
};

const dataTables = [
  {
    table: [
      {
        startTime: Timestamp.fromDate(new Date('2022-04-01T04:00:00Z')),
        endTime: Timestamp.fromDate(new Date('2022-05-01T04:00:00Z')),
        groups: [],
        value: 95,
        defaultValue: 0,
        isPartialPeriod: false,
      },
      {
        startTime: Timestamp.fromDate(new Date('2022-05-01T04:00:00Z')),
        endTime: Timestamp.fromDate(new Date('2022-06-01T04:00:00Z')),
        groups: [],
        value: 274,
        defaultValue: 0,
        isPartialPeriod: false,
      },
      {
        startTime: Timestamp.fromDate(new Date('2022-06-01T04:00:00Z')),
        endTime: Timestamp.fromDate(new Date('2022-07-01T04:00:00Z')),
        groups: [],
        value: 313,
        defaultValue: 0,
        isPartialPeriod: false,
      },
      {
        startTime: Timestamp.fromDate(new Date('2022-07-01T04:00:00Z')),
        endTime: Timestamp.fromDate(new Date('2022-08-01T04:00:00Z')),
        groups: [],
        value: 321,
        defaultValue: 0,
        isPartialPeriod: false,
      },
    ],
    numGroups: int64.fromNumber(0),
  },
];

const previousDataTables = [
  {
    table: [
      {
        startTime: Timestamp.fromDate(new Date('2022-03-01T04:00:00Z')),
        endTime: Timestamp.fromDate(new Date('2022-04-01T04:00:00Z')),
        groups: [],
        value: 321,
        defaultValue: 0,
        isPartialPeriod: false,
      },
      {
        startTime: Timestamp.fromDate(new Date('2022-04-01T04:00:00Z')),
        endTime: Timestamp.fromDate(new Date('2022-05-01T04:00:00Z')),
        groups: [],
        value: 95,
        defaultValue: 0,
        isPartialPeriod: false,
      },
      {
        startTime: Timestamp.fromDate(new Date('2022-05-01T04:00:00Z')),
        endTime: Timestamp.fromDate(new Date('2022-06-01T04:00:00Z')),
        groups: [],
        value: 274,
        defaultValue: 0,
        isPartialPeriod: false,
      },
      {
        startTime: Timestamp.fromDate(new Date('2022-06-01T04:00:00Z')),
        endTime: Timestamp.fromDate(new Date('2022-07-01T04:00:00Z')),
        groups: [],
        value: 313,
        defaultValue: 0,
        isPartialPeriod: false,
      },
      {
        startTime: Timestamp.fromDate(new Date('2022-07-01T04:00:00Z')),
        endTime: Timestamp.fromDate(new Date('2022-08-01T04:00:00Z')),
        groups: [],
        value: 321,
        defaultValue: 0,
        isPartialPeriod: false,
      },
    ],
    numGroups: int64.fromNumber(0),
  },
];

const metricRecord = {
  metric: {
    id: 'o2buL97A5hnG',
    name: 'Test Metric',
    description: '',
    metric: {
      single: {
        event: {
          primary: null,
          deps: [],
        },
        aggregation: {
          unique: 1,
        },
        rollingWindow: 0,
        rollingWindowType: 0,
        rollingWindowInterval: TimeInterval.TIME_INTERVAL_INVALID,
      },
    },
    trend: {
      frequency: 4,
      computePast: false,
      segmentId: [],
      conversionId: [],
      displayAs: {
        displayPrecision: 1,
        number: true,
      },
      timeRange: {
        startTime: 'NOW/DAY-364DAY',
        endTime: 'NOW/DAY+1DAY',
      },
      segment: [
        {
          segmentId: 'everyone',
          segmentScope: 3,
        },
      ],
      dimensionSettings: {
        dimension: null,
        dimensions: [],
        sortOrder: SortOrder.SORT_ORDER_DESC,
        sortByDefault: false,
        sortType: SortType.SORT_TYPE_INVALID,
        limit: 50,
        computeTopLevel: false,
        computeNumGroups: false,
        allowAllPartialResults: false,
        noFallback: false,
      },
      timeRangeComparison: null,
      color: 0,
    },
    funnelFilter: null,
  },
  metadata: {
    lastUpdated: Timestamp.fromDate(new Date('2023-04-11T20:15:54.618079Z')),
    lastUpdatedBy: 'klint@fullstory.com',
    created: Timestamp.fromDate(new Date('2023-04-11T20:15:39.070133Z')),
    createdBy: 'klint@fullstory.com',
    archived: false,
    visibility: Visibility.PUBLIC,
    version: int64.fromNumber(1681244154618),
    sequentialVersion: int64.fromNumber(2),
  },
  isDcmCreated: false,
  isCanned: false,
};

const defaultUserAlertPreferences: UserAlertPreference[] = [
  {
    user: {
      email: 'test1@fullstory.com',
      firstName: 'Test',
      lastName: 'Account 1',
    },
    subscribedInApp: true,
    subscribedEmail: false,
  },
  {
    user: {
      email: 'test2@fullstory.com',
      firstName: 'Test',
      lastName: 'Account 2',
    },
    subscribedInApp: false,
    subscribedEmail: true,
  },
  {
    user: {
      email: 'test5@fullstory.com',
      firstName: 'Test',
      lastName: 'Account 5',
    },
    subscribedInApp: true,
    subscribedEmail: true,
  },
  {
    user: {
      email: 'test7@fullstory.com',
      firstName: 'Test',
      lastName: 'Account 7',
    },
    subscribedInApp: true,
    subscribedEmail: true,
  },
];

export const GET_CREATE_ALERT_VIEW_RESPONSE_WITH_VALUE_THRESHOLD: GetCreateAlertViewResponse = {
  metricRecord,
  legendItems: [
    {
      segmentLegend: {
        id: 'everyone',
        name: 'Everyone',
      },
    },
  ],
  dataTables,
  previousDataTables,
  alertNotificationConfig: {
    alertConfig: {
      id: 'OhGjeuYOtHcS',
      hash: 'proactiveinsights.AlertConfig:347e6e50f3090dd1ba8419cd649e356e582b19da',
      lastHashChange: Timestamp.fromDate(new Date('2023-04-20T19:35:19.416346971Z')),
      name: 'Test Edit Alert',
      description: 'Test edit description',
      dxIdVersion: {
        id: '1234',
        version: int64.fromNumber(1681244154618),
        supportedDxObjectType: 1,
      },
      algorithmVersion: 0,
      timeZone: 'America/New_York',
      absoluteThreshold: {
        threshold: 200,
        operation: ThresholdOperation.THRESHOLD_OPERATION_GREATER_THAN,
        triggerWhileThresholdCrossed: false,
      },
    },
    destinationIds: [],
    alertConfigCreator: 'test@fullstory.com',
    userAlertPreferences: defaultUserAlertPreferences,
  },
  allUsers: DEFAULT_ALL_USERS,
};

export const GET_CREATE_ALERT_VIEW_RESPONSE_WITH_ABSOLUTE_CHANGE: GetCreateAlertViewResponse = {
  metricRecord,
  legendItems: [
    {
      segmentLegend: {
        id: 'everyone',
        name: 'Everyone',
      },
    },
  ],
  dataTables,
  previousDataTables,
  alertNotificationConfig: {
    alertConfig: {
      id: 'OhGjeuYOtHcS',
      hash: 'proactiveinsights.AlertConfig:347e6e50f3090dd1ba8419cd649e356e582b19da',
      lastHashChange: Timestamp.fromDate(new Date('2023-04-20T19:35:19.416346971Z')),
      name: 'Test Edit Alert',
      description: 'Test edit description',
      dxIdVersion: {
        id: '1234',
        version: int64.fromNumber(1681244154618),
        supportedDxObjectType: 1,
      },
      algorithmVersion: 0,
      timeZone: 'America/New_York',
      absoluteChangeThreshold: {
        threshold: 45,
        direction: AlertDirection.ALERT_DIRECTION_INCREASING,
      },
    },
    destinationIds: [],
    alertConfigCreator: 'test@fullstory.com',
    userAlertPreferences: defaultUserAlertPreferences,
  },
  allUsers: DEFAULT_ALL_USERS,
};

export const GET_CREATE_ALERT_VIEW_RESPONSE_WITH_RELATIVE_CHANGE: GetCreateAlertViewResponse = {
  metricRecord,
  legendItems: [
    {
      segmentLegend: {
        id: 'everyone',
        name: 'Everyone',
      },
    },
  ],
  dataTables,
  previousDataTables,
  alertNotificationConfig: {
    alertConfig: {
      id: 'OhGjeuYOtHcS',
      hash: 'proactiveinsights.AlertConfig:347e6e50f3090dd1ba8419cd649e356e582b19da',
      lastHashChange: Timestamp.fromDate(new Date('2023-04-20T19:35:19.416346971Z')),
      name: 'Test Edit Alert',
      description: 'Test edit description',
      dxIdVersion: {
        id: '1234',
        version: int64.fromNumber(1681244154618),
        supportedDxObjectType: 1,
      },
      algorithmVersion: 0,
      timeZone: 'America/New_York',
      relativeChangeThreshold: {
        threshold: 10,
        direction: AlertDirection.ALERT_DIRECTION_DECREASING,
      },
    },
    destinationIds: [],
    alertConfigCreator: 'test@fullstory.com',
    userAlertPreferences: defaultUserAlertPreferences,
  },
  allUsers: DEFAULT_ALL_USERS,
};

// coped from https://app.staging.fullstory.com/ui/thefullstory.com/metrics/details/L31LpDifZy38/alerts/tuUhEd4SnGjC?triggerId=U7rQC4depsyq
export const GET_ALERTS_DETAIL_RESPONSE = {
  metricRecord: {
    metric: {
      id: 'L31LpDifZy38',
      name: 'Send Note authorization error',
      description: '',
      metric: {
        single: {
          event: {
            primary: {
              definedEvent: {
                withId: {
                  value: 'ZlO6tXuPAu9a',
                },
              },
            },
            deps: [],
          },
          aggregation: {
            unique: 2,
          },
          rollingWindow: 0,
          rollingWindowType: 0,
          rollingWindowInterval: 0,
        },
      },
      trend: {
        frequency: 1,
        computePast: false,
        segmentId: [],
        conversionId: [],
        displayAs: {
          displayPrecision: 1,
          number: true,
        },
        timeRange: {
          startTime: 'NOW/DAY-29DAY',
          endTime: 'NOW/DAY+1DAY',
        },
        segment: [
          {
            segmentId: 'timchin@fullstory.com:5455939174465536',
            segmentScope: 3,
          },
        ],
        dimensionSettings: {
          dimension: null,
          dimensions: [],
          sortOrder: SortOrder.SORT_ORDER_DESC,
          sortByDefault: false,
          sortType: SortType.SORT_TYPE_INVALID,
          limit: 50,
          computeTopLevel: false,
          computeNumGroups: false,
          allowAllPartialResults: false,
          noFallback: false,
        },
        timeRangeComparison: null,
        color: 0,
      },
      funnelFilter: null,
    },
    metadata: {
      lastUpdated: Timestamp.fromDate(new Date('2023-04-20T21:21:15.961162Z')),
      lastUpdatedBy: 'joshrynne@fullstory.com',
      created: Timestamp.fromDate(new Date('2022-08-23T14:34:11.527952Z')),
      createdBy: 'joshrynne@fullstory.com',
      archived: false,
      visibility: Visibility.PUBLIC,
      version: int64.fromNumber(1682025675961),
      sequentialVersion: int64.fromNumber(4),
    },
    isDcmCreated: false,
    isCanned: false,
  },
  legendItems: [
    {
      segmentLegend: {
        id: 'timchin@fullstory.com:5455939174465536',
        name: 'Not fullstory',
      },
    },
  ],
  alertNotificationConfig: {
    alertConfig: {
      id: 'tuUhEd4SnGjC',
      hash: 'proactiveinsights.AlertConfig:9050162a73415186835fde45564a8c30434211f5',
      lastHashChange: Timestamp.fromDate(new Date('2023-04-20T21:25:09.245847644Z')),
      name: 'Send note auth errors > 5 daily',
      description:
        'More than 5 users encountered the "Send note authorization error" when attempting to send a note to an integration',
      dxIdVersion: {
        id: 'L31LpDifZy38',
        version: int64.fromNumber(1682025675961),
        supportedDxObjectType: 1,
      },
      algorithmVersion: 0,
      timeZone: 'America/New_York',
      absoluteThreshold: {
        threshold: 5,
        operation: 1,
        triggerWhileThresholdCrossed: false,
      },
    },
    alertConfigCreator: 'test@fullstory.com',
    destinationIds: ['1'],
    userAlertPreferences: [
      {
        user: {
          email: 'test@fullstory.com',
          firstName: 'Test',
          lastName: 'Account',
        },
        subscribedInApp: true,
        subscribedEmail: false,
      },
    ],
  },
  alertIdsForMetric: ['tuUhEd4SnGjC'],
  alertTriggers: [
    {
      triggerId: 'U7rQC4depsyq',
      alertTimes: {
        start: Timestamp.fromDate(new Date('2023-04-24T04:00:00Z')),
        end: Timestamp.fromDate(new Date('2023-04-25T04:00:00Z')),
      },
      isHistorical: false,
      triggerValue: 9,
    },
  ],
  alertDataTables: [
    {
      table: [
        {
          startTime: Timestamp.fromDate(new Date('2023-03-22T04:00:00Z')),
          endTime: Timestamp.fromDate(new Date('2023-03-23T04:00:00Z')),
          groups: [],
          value: 0,
          defaultValue: 0,
          isPartialPeriod: false,
        },
        {
          startTime: Timestamp.fromDate(new Date('2023-03-23T04:00:00Z')),
          endTime: Timestamp.fromDate(new Date('2023-03-24T04:00:00Z')),
          groups: [],
          value: 0,
          defaultValue: 0,
          isPartialPeriod: false,
        },
        {
          startTime: Timestamp.fromDate(new Date('2023-03-24T04:00:00Z')),
          endTime: Timestamp.fromDate(new Date('2023-03-25T04:00:00Z')),
          groups: [],
          value: 0,
          defaultValue: 0,
          isPartialPeriod: false,
        },
        {
          startTime: Timestamp.fromDate(new Date('2023-03-25T04:00:00Z')),
          endTime: Timestamp.fromDate(new Date('2023-03-26T04:00:00Z')),
          groups: [],
          value: 0,
          defaultValue: 0,
          isPartialPeriod: false,
        },
        {
          startTime: Timestamp.fromDate(new Date('2023-03-26T04:00:00Z')),
          endTime: Timestamp.fromDate(new Date('2023-03-27T04:00:00Z')),
          groups: [],
          value: 0,
          defaultValue: 0,
          isPartialPeriod: false,
        },
        {
          startTime: Timestamp.fromDate(new Date('2023-03-27T04:00:00Z')),
          endTime: Timestamp.fromDate(new Date('2023-03-28T04:00:00Z')),
          groups: [],
          value: 0,
          defaultValue: 0,
          isPartialPeriod: false,
        },
        {
          startTime: Timestamp.fromDate(new Date('2023-03-28T04:00:00Z')),
          endTime: Timestamp.fromDate(new Date('2023-03-29T04:00:00Z')),
          groups: [],
          value: 0,
          defaultValue: 0,
          isPartialPeriod: false,
        },
        {
          startTime: Timestamp.fromDate(new Date('2023-03-29T04:00:00Z')),
          endTime: Timestamp.fromDate(new Date('2023-03-30T04:00:00Z')),
          groups: [],
          value: 0,
          defaultValue: 0,
          isPartialPeriod: false,
        },
        {
          startTime: Timestamp.fromDate(new Date('2023-03-30T04:00:00Z')),
          endTime: Timestamp.fromDate(new Date('2023-03-31T04:00:00Z')),
          groups: [],
          value: 1,
          defaultValue: 0,
          isPartialPeriod: false,
        },
        {
          startTime: Timestamp.fromDate(new Date('2023-03-31T04:00:00Z')),
          endTime: Timestamp.fromDate(new Date('2023-04-01T04:00:00Z')),
          groups: [],
          value: 7,
          defaultValue: 0,
          isPartialPeriod: false,
        },
        {
          startTime: Timestamp.fromDate(new Date('2023-04-01T04:00:00Z')),
          endTime: Timestamp.fromDate(new Date('2023-04-02T04:00:00Z')),
          groups: [],
          value: 1,
          defaultValue: 0,
          isPartialPeriod: false,
        },
        {
          startTime: Timestamp.fromDate(new Date('2023-04-02T04:00:00Z')),
          endTime: Timestamp.fromDate(new Date('2023-04-03T04:00:00Z')),
          groups: [],
          value: 0,
          defaultValue: 0,
          isPartialPeriod: false,
        },
        {
          startTime: Timestamp.fromDate(new Date('2023-04-03T04:00:00Z')),
          endTime: Timestamp.fromDate(new Date('2023-04-04T04:00:00Z')),
          groups: [],
          value: 9,
          defaultValue: 0,
          isPartialPeriod: false,
        },
        {
          startTime: Timestamp.fromDate(new Date('2023-04-04T04:00:00Z')),
          endTime: Timestamp.fromDate(new Date('2023-04-05T04:00:00Z')),
          groups: [],
          value: 6,
          defaultValue: 0,
          isPartialPeriod: false,
        },
        {
          startTime: Timestamp.fromDate(new Date('2023-04-05T04:00:00Z')),
          endTime: Timestamp.fromDate(new Date('2023-04-06T04:00:00Z')),
          groups: [],
          value: 5,
          defaultValue: 0,
          isPartialPeriod: false,
        },
        {
          startTime: Timestamp.fromDate(new Date('2023-04-06T04:00:00Z')),
          endTime: Timestamp.fromDate(new Date('2023-04-07T04:00:00Z')),
          groups: [],
          value: 6,
          defaultValue: 0,
          isPartialPeriod: false,
        },
        {
          startTime: Timestamp.fromDate(new Date('2023-04-07T04:00:00Z')),
          endTime: Timestamp.fromDate(new Date('2023-04-08T04:00:00Z')),
          groups: [],
          value: 2,
          defaultValue: 0,
          isPartialPeriod: false,
        },
        {
          startTime: Timestamp.fromDate(new Date('2023-04-08T04:00:00Z')),
          endTime: Timestamp.fromDate(new Date('2023-04-09T04:00:00Z')),
          groups: [],
          value: 2,
          defaultValue: 0,
          isPartialPeriod: false,
        },
        {
          startTime: Timestamp.fromDate(new Date('2023-04-09T04:00:00Z')),
          endTime: Timestamp.fromDate(new Date('2023-04-10T04:00:00Z')),
          groups: [],
          value: 4,
          defaultValue: 0,
          isPartialPeriod: false,
        },
        {
          startTime: Timestamp.fromDate(new Date('2023-04-10T04:00:00Z')),
          endTime: Timestamp.fromDate(new Date('2023-04-11T04:00:00Z')),
          groups: [],
          value: 1,
          defaultValue: 0,
          isPartialPeriod: false,
        },
        {
          startTime: Timestamp.fromDate(new Date('2023-04-11T04:00:00Z')),
          endTime: Timestamp.fromDate(new Date('2023-04-12T04:00:00Z')),
          groups: [],
          value: 4,
          defaultValue: 0,
          isPartialPeriod: false,
        },
        {
          startTime: Timestamp.fromDate(new Date('2023-04-12T04:00:00Z')),
          endTime: Timestamp.fromDate(new Date('2023-04-13T04:00:00Z')),
          groups: [],
          value: 4,
          defaultValue: 0,
          isPartialPeriod: false,
        },
        {
          startTime: Timestamp.fromDate(new Date('2023-04-13T04:00:00Z')),
          endTime: Timestamp.fromDate(new Date('2023-04-14T04:00:00Z')),
          groups: [],
          value: 7,
          defaultValue: 0,
          isPartialPeriod: false,
        },
        {
          startTime: Timestamp.fromDate(new Date('2023-04-14T04:00:00Z')),
          endTime: Timestamp.fromDate(new Date('2023-04-15T04:00:00Z')),
          groups: [],
          value: 4,
          defaultValue: 0,
          isPartialPeriod: false,
        },
        {
          startTime: Timestamp.fromDate(new Date('2023-04-15T04:00:00Z')),
          endTime: Timestamp.fromDate(new Date('2023-04-16T04:00:00Z')),
          groups: [],
          value: 0,
          defaultValue: 0,
          isPartialPeriod: false,
        },
        {
          startTime: Timestamp.fromDate(new Date('2023-04-16T04:00:00Z')),
          endTime: Timestamp.fromDate(new Date('2023-04-17T04:00:00Z')),
          groups: [],
          value: 1,
          defaultValue: 0,
          isPartialPeriod: false,
        },
        {
          startTime: Timestamp.fromDate(new Date('2023-04-17T04:00:00Z')),
          endTime: Timestamp.fromDate(new Date('2023-04-18T04:00:00Z')),
          groups: [],
          value: 3,
          defaultValue: 0,
          isPartialPeriod: false,
        },
        {
          startTime: Timestamp.fromDate(new Date('2023-04-18T04:00:00Z')),
          endTime: Timestamp.fromDate(new Date('2023-04-19T04:00:00Z')),
          groups: [],
          value: 8,
          defaultValue: 0,
          isPartialPeriod: false,
        },
        {
          startTime: Timestamp.fromDate(new Date('2023-04-19T04:00:00Z')),
          endTime: Timestamp.fromDate(new Date('2023-04-20T04:00:00Z')),
          groups: [],
          value: 9,
          defaultValue: 0,
          isPartialPeriod: false,
        },
        {
          startTime: Timestamp.fromDate(new Date('2023-04-20T04:00:00Z')),
          endTime: Timestamp.fromDate(new Date('2023-04-21T04:00:00Z')),
          groups: [],
          value: 6,
          defaultValue: 0,
          isPartialPeriod: false,
        },
        {
          startTime: Timestamp.fromDate(new Date('2023-04-21T04:00:00Z')),
          endTime: Timestamp.fromDate(new Date('2023-04-22T04:00:00Z')),
          groups: [],
          value: 5,
          defaultValue: 0,
          isPartialPeriod: false,
        },
        {
          startTime: Timestamp.fromDate(new Date('2023-04-22T04:00:00Z')),
          endTime: Timestamp.fromDate(new Date('2023-04-23T04:00:00Z')),
          groups: [],
          value: 0,
          defaultValue: 0,
          isPartialPeriod: false,
        },
        {
          startTime: Timestamp.fromDate(new Date('2023-04-23T04:00:00Z')),
          endTime: Timestamp.fromDate(new Date('2023-04-24T04:00:00Z')),
          groups: [],
          value: 0,
          defaultValue: 0,
          isPartialPeriod: false,
        },
        {
          startTime: Timestamp.fromDate(new Date('2023-04-24T04:00:00Z')),
          endTime: Timestamp.fromDate(new Date('2023-04-25T04:00:00Z')),
          groups: [],
          value: 9,
          defaultValue: 0,
          isPartialPeriod: false,
        },
        {
          startTime: Timestamp.fromDate(new Date('2023-04-25T04:00:00Z')),
          endTime: Timestamp.fromDate(new Date('2023-04-26T04:00:00Z')),
          groups: [],
          value: 5,
          defaultValue: 0,
          isPartialPeriod: false,
        },
      ],
      numGroups: int64.zero,
    },
  ],
  alertPreviousDataTables: [],
  createdBy: 'joshrynne@fullstory.com',
  graphStart: Timestamp.fromDate(new Date('2023-03-28T04:00:00Z')),
  alertCreated: Timestamp.fromDate(new Date('2023-03-28T04:00:00Z')),
  accessControl: {
    id: '',
    canRead: true,
    canUpdate: true,
    canDelete: true,
    canCreate: true,
    owners: ['joshrynne@fullstory.com'],
  },
};
